import { Stats, PatternItem } from "./Stats";
import React from "react";

export const PrimeStats = ({dataList, gameName}) => {
    console.log('Rendering PrimeStats')
    const patternFunc = (results) => {
        return results.map((result, index) => isPrime(result) ? <PatternItem key={index} color="#00ff5a">P</PatternItem>: <PatternItem key={index} color="#ff9900">C</PatternItem>)
    }

    const ratioFunc = (results) => {
        const primeCount = results.filter((result) => isPrime(result)).length
        return `${primeCount} : ${results.length - primeCount}`
    }

    const isPrime = (number) => {
        if (number <= 1) {
          return false; // Numbers less than or equal to 1 are not prime
        }
      
        for (let i = 2; i <= Math.sqrt(number); i++) {
          if (number % i === 0) {
            return false; // Divisible by a number other than 1 and itself, so not prime
          }
        }
      
        return true; // If not divisible by any number other than 1 and itself, it is prime
    }

    return (
        <Stats
            dataList={dataList}
            patternFunc={patternFunc}
            ratioFunc={ratioFunc}
            gameName={gameName}
        />
    )
}
